import MultipleLanguagesIcon from './multipleLanguages.svg';
import rtlSupportIcon from './rtlSupport.svg';

export { MultipleLanguagesIcon, rtlSupportIcon };
